import { useQuery } from "@tanstack/react-query";
import { Permission, PermissionService } from "../../../../../services/config/permission-config/permission";
import { useMemo } from "react";

export const usePermission = () => {
  const { data = [], ...restResponse } = useQuery<Permission[]>({
    queryKey: ["config-permission"],
    queryFn: () => PermissionService.getList(),
  });

  const listPermissions = useMemo(
    () =>
      data
        ? data.map((permission: Permission) => ({
            title: permission.permissionName,
            key: permission.code,
          }))
        : [],
    [data]
  );

  return {
    ...restResponse,
    listPermissions,
  };
};
